<template>
    <div>
        <h2 class="primary darken-2 white--text  py-1 text-xs-center"><span>SAVE INTO:</span> {{ campaign.name }}</h2>
        <v-divider></v-divider>

        <v-card class="pa-1" style="" >
            <v-card-text class="pa-1" style="font-size: 12px; ">
                <p class="dark--text subheading pa-0 ma-0"><b>Amount Saved:</b> <span> {{ campaign.saved_amount }}/{{ campaign.target_amount }} FCFA</span></p>
                <p class="dark--text caption pa-0 ma-0 text-xs-center"><span> <b>Note:</b> Saving here is by <b>MTN Mobile Money</b> <b> or Orange Money</b> to <b>Name:</b> <u> "Petty Cash SAS"</u></span></p>
            </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card color="white pa-3 " style="border-radius:" >
            <v-layout row>
                <v-flex xs12 md10 offset-md1>
                    <input type="hidden" v-model="payment_ref" ref="payment_ref" id="payment_ref">

                    <!-- ─── Montant ─── -->
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-money-bill fa-2x mt-3"> </i>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-text-field
                                class="pa-0 mt-2"
                                id="save_amount" ref="save_amount" v-model="save_amount"
                                label="Input amount to save (F CFA)"
                                :rules="[v => !!v || 'Your amount to save is required']"
                                required
                                color="teal"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs2 >
                            <v-btn @click.stop="$store.commit('activateDialog', true); save_amount_help = true; getHelpMessage()" flat fab small outline color="black" class="mt-4" style="height:20px; width: 20px" >
                                <i class="fas fa-question"> </i>
                            </v-btn>
                        </v-flex>
                    </v-layout>

                    <!-- ─── Numéro de téléphone ─── -->
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-phone fa-2x "> </i>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <input @click="clearPhoneField()" id="phone" required type="tel" value="Enter Phone Number" ref="phone_number" v-model="phone_number" name="phone" class="py-2 my-2" style="width: 100%!important; border-bottom: 1px grey solid" />
                        </v-flex>
                        <v-flex xs2 >
                            <v-btn @click.stop="$store.commit('activateDialog', true); save_contact_help = true; getHelpMessage()" flat fab small outline color="black" class="my-2" style="height:20px; width: 20px" >
                                <i class="fas fa-question"> </i>
                            </v-btn>
                        </v-flex>
                    </v-layout>

                    <!-- ─── Badge réseau détecté ─── -->
                    <v-layout row v-if="detectedNetwork">
                        <v-flex xs9 offset-xs2 sm10 offset-sm1 class="pt-1 pb-2">
                            <v-chip
                                small
                                label
                                :color="detectedNetwork === 'MTN' ? 'amber darken-1' : detectedNetwork === 'Nexttel' ? 'blue darken-1' : 'orange darken-2'"
                                class="white--text ma-0"
                            >
                                <v-icon left small class="white--text">fas fa-check-circle</v-icon>
                                Network detected :&nbsp;<strong>{{
                                    detectedNetwork === 'MTN' ? 'MTN Mobile Money' :
                                    detectedNetwork === 'Nexttel' ? 'Nexttel' :
                                    'Orange Money'
                                }}</strong>
                            </v-chip>
                            <span class="caption red--text ml-1" v-if="detectedNetwork === 'MTN' || detectedNetwork === 'Orange'">
                                (Operator locked automatically)
                            </span>
                        </v-flex>
                    </v-layout>

                    <!-- ─── Sélection opérateur (Sécurisée et verrouillable) ─── -->
                    <v-layout row wrap>
                        <v-flex xs12 class="pt-3">
                            <h3><i class="teal--text fas fa-wrench"> </i> Select Transactor Operator</h3>
                        </v-flex>

                        <!-- MTN Bloquable -->
                        <v-flex xs6 sm3 md4 offset-sm1 class="pt-2" @click="isOperatorLocked ? null : selectMoMo()">
                            <v-img
                                :src="require('@/assets/mtn-mobile-money-logo.png')"
                                :style="{ cursor: isOperatorLocked ? 'not-allowed' : 'pointer', opacity: isOperatorLocked && !momo_choice ? 0.4 : 1 }"
                                contain width="100"
                            ></v-img>
                            <v-checkbox v-model="momo_choice" :disabled="isOperatorLocked" label="MTN MoMo" hide-details class="ma-1" id="selected_momo">
                            </v-checkbox>
                        </v-flex>

                        <!-- OM Bloquable -->
                        <v-flex xs6 sm3 class="pt-2" @click="isOperatorLocked ? null : selectOM()">
                            <v-img
                                :src="require('@/assets/om.png')"
                                :style="{ cursor: isOperatorLocked ? 'not-allowed' : 'pointer', opacity: isOperatorLocked && !om_choice ? 0.4 : 1 }"
                                contain width="70"
                            ></v-img>
                            <v-checkbox v-model="om_choice" :disabled="isOperatorLocked" label="OM" hide-details class="ma-1" id="selected_om">
                            </v-checkbox>
                        </v-flex>

                        <!-- Petty Cash Bloquable -->
                        <v-flex xs12 sm4 class="pt-4 mt-3" @click="isOperatorLocked ? null : selectPettyCash()">
                            <v-img
                                :src="require('@/assets/logo-2.png')"
                                :style="{ cursor: isOperatorLocked ? 'not-allowed' : 'pointer', opacity: isOperatorLocked ? 0.4 : 1 }"
                                contain width="200"
                            ></v-img>
                            <v-checkbox v-model="pettycash_choice" :disabled="isOperatorLocked" label="Petty Cash" hide-details class="ma-1" id="selected_petty_cash">
                            </v-checkbox>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <div class=" text-xs-right">
                <v-btn :disabled="totalRequests >= 3" class="white--text" @click="changeTelDial()" small round color="teal darken-2">
                    <span> Save</span>
                </v-btn>
            </div>
            <v-dialog width="500px" v-model="Dialog">
                <v-card>
                    <v-card-title class="headline primary darken-2 white--text" primary-title>Confirm Deposit</v-card-title>
                    <v-card-text class="pa-4">
                        <p class=" mb-0">By clicking <b class="teal--text darken-2">Confirm</b>, a deposit transaction of <b>{{ save_amount }} F CFA</b> will be triggered by you through <b>{{ transaction_operator }}</b> from the phone number <b>{{ phone_number }}</b></p>
                        <div v-if="transaction_operator === 'MTN Mobile Money' || transaction_operator === 'Orange Money'">
                            <p class=" mb-0">If you are facing difficulties, send manually through the code below:</p>
                            <p class="pl-2 mb-0 pt-1 red--text"> - <b>{{ transfer_code }}</b></p>
                            <p class="pl-2 mb-0 pt-1 " v-if="transaction_operator === 'MTN Mobile Money'"> - Choose reference 1</p>
                            <p class="pl-2 mb-0 pt-1 " v-if="transaction_operator === 'Orange Money'"> - Input transaction amount</p>
                            <p class="pl-2 mb-0 pt-1 "> - Click <b class="teal--text darken-2">Confirm</b> below</p>
                        </div>
                    </v-card-text>

                    <v-card-actions class="px-3">
                        <v-btn color="teal" flat @click="Dialog = false" > Cancel </v-btn>
                        <v-spacer></v-spacer>
                        <a id="dial_transaction" >
                            <v-btn color="teal darken-2" class="white--text" @click="saveMoneyCampaign()" > Confirm </v-btn>
                        </a>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {

        data() {
            return {
                momo_choice: false,
                om_choice: false,
                pettycash_choice: false,

                Dialog: false,
                text: "The transaction will be updated to your campaign after the transaction id is verified",
                save_amount_help: false,
                save_contact_help: false,
                save_transaction_code_help: false,
                save_operator_help: false,
                phoneInput: null,
                campaign: {},
                operators: [],
                totalRequests: 0,

                save_amount: "",
                transfer_code: "",
                payment_ref: "",
                phone_number: "Enter Phone Number",
                transaction_operator: "",

                detectedNetwork: null,
            }
        },

        computed: {
            // Détermine dynamiquement s'il faut geler la sélection manuelle
            isOperatorLocked() {
                return this.detectedNetwork === 'MTN' || this.detectedNetwork === 'Orange';
            }
        },

        async mounted(){
            this.getCampaignDetail();
            this.getOperators();
            this.initialiseIntel();
            this.getCampaignPaymentRef();
            document.title = "PettyCash | Save into Campaign"
            this.$store.commit('setCloseURL', "/market_place/campaign/detail/"+this.$route.params.campaign_id)

            const campaign_id = this.$route.params.campaign_id;
            if (campaign_id) {
                try {
                    const response = await axios.get(`/api/v1/savings/total/${campaign_id}/`);
                    this.totalRequests = response.data.total_requests;
                } catch (error) {
                    console.error("Error fetching total requests on mount:", error);
                }
            }
        },

        methods: {
            clearPhoneField() {
                if (this.phone_number === "Enter Phone Number") {
                    this.phone_number = ""
                }
            },

            detectNetwork() {
                if (!this.phoneInput || typeof this.phoneInput.getNumber !== 'function') return;

                const fullNumber = this.phoneInput.getNumber();
                if (!fullNumber) {
                    this.resetSelection();
                    return;
                }

                const national = fullNumber.replace(/^(\+237|237)/, '').replace(/\s/g, '');

                if (national.length !== 9 || !national.startsWith('6')) {
                    this.resetSelection();
                    return;
                }

                const prefix = national.substring(0, 3);

                if (/^6(5[0-4]|7[0-9]|8[0-3])\d*/.test(prefix)) {
                    this.detectedNetwork = 'MTN';
                    this.selectMoMo();
                } else if (/^6(5[5-9]|9[0-9])\d*/.test(prefix)) {
                    this.detectedNetwork = 'Orange';
                    this.selectOM();
                } else if (/^6(6[0-9])\d*/.test(prefix)) {
                    this.detectedNetwork = 'Nexttel';
                    this.resetOperatorChoice();
                } else if (/^6(2[0-0])\d*/.test(prefix)) {
                    this.detectedNetwork = 'Camtel';
                    this.resetOperatorChoice();
                } else {
                    this.resetSelection();
                }
            },

            resetSelection() {
                this.detectedNetwork = null;
                this.resetOperatorChoice();
            },

            resetOperatorChoice() {
                this.momo_choice = false;
                this.om_choice = false;
                this.pettycash_choice = false;
                this.transaction_operator = "";
            },

            selectMoMo() {
                this.momo_choice = true
                this.om_choice = false
                this.pettycash_choice = false
                this.transaction_operator = "MTN Mobile Money"
            },

            selectOM() {
                this.momo_choice = false
                this.om_choice = true
                this.pettycash_choice = false
                this.transaction_operator = "Orange Money"
            },

            selectPettyCash() {
                this.momo_choice = false
                this.om_choice = false
                this.pettycash_choice = true
                this.transaction_operator = ""

                this.$store.commit('setSnackBarMessage', "This option is currently unavaible")
                this.$store.commit('setSnackBarColor', "teal darken-4")
                this.$store.commit('activateSnackBar', true)
            },

            initialiseIntel() {
                function getIp(callback) {
                    fetch('https://ipinfo.io/json?token=fa5e74d3e65812', { headers: { 'Accept': 'application/json' }})
                    .then((resp) => resp.json())
                    .catch(() => ({ country: 'cm' }))
                    .then((resp) => callback(resp.country));
                }

                const phoneInputField = document.querySelector("#phone");
                this.phoneInput = window.intlTelInput(phoneInputField, {
                    initialCountry: "cm",
                    geoIpLookup: getIp,
                    preferredCountries: ["cm", "us", "uk", "ci", "cg", "cf", "td", "ng", "gq", "ga"],
                    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
                });

                phoneInputField.addEventListener('input', () => this.detectNetwork());
                phoneInputField.addEventListener('countrychange', () => this.detectNetwork());
            },

            async getCampaignDetail() {
                this.$store.commit('setIsLoading', true)
                const campaign_id = this.$route.params.campaign_id
                await axios
                    .get('/api/v1/savings/get/user/campaign/detail/'+campaign_id+'/')
                    .then(response => {
                        this.campaign = response.data
                    })
                    .catch(error => {
                        if (error.response){
                            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }else{
                            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }
                    })
                this.$store.commit('setIsLoading', false)
            },

            async getCampaignPaymentRef() {
                this.$store.commit('setIsLoading', true)
                const campaign_id = this.$route.params.campaign_id
                await axios
                    .get('/api/v1/savings/create/user/save/campaign/payment_ref/'+campaign_id+'/')
                    .then(response => {
                        this.payment_ref = response.data
                    })
                    .catch(error => {
                        if (error.response){
                            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }else{
                            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }
                    })
                this.$store.commit('setIsLoading', false)
            },

            async getOperators() {
                this.$store.commit('setIsLoading', true)
                await axios
                    .get('/api/v1/home/get/operators/info/')
                    .then(response => {
                        this.operators = response.data
                    })
                    .catch(error => {
                        if (error.response){
                            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }else{
                            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }
                    })
                this.$store.commit('setIsLoading', false)
            },

            async changeTelDial() {
                const campaign_id = this.$route.params.campaign_id;
                if (!campaign_id) return;

                try {
                    const response = await axios.get(`/api/v1/savings/total/${campaign_id}/`);
                    this.totalRequests = response.data.total_requests;

                    if (this.totalRequests >= 3) {
                        this.$store.commit('setSnackBarMessage', "You have reached the limit of 3 requests per day.");
                        this.$store.commit('setSnackBarColor', "red darken-4");
                        this.$store.commit('activateSnackBar', true);
                        return;
                    }

                    if (!this.save_amount || this.save_amount === "" || isNaN(Number(this.save_amount)) || Number(this.save_amount) <= 0) {
                        let message = this.save_amount === "" ? "Please input the amount" : "Please input only numbers for the amount";
                        this.$store.commit('setSnackBarMessage', message);
                        this.$store.commit('setSnackBarColor', "red darken-4");
                        this.$store.commit('activateSnackBar', true);
                        document.getElementById('dial_transaction').setAttribute('href', "");
                        this.$refs.save_amount.focus();
                    } else if (this.transaction_operator === "") {
                        this.$store.commit('setSnackBarMessage', "Please select the operator.");
                        this.$store.commit('setSnackBarColor', "red darken-4");
                        this.$store.commit('activateSnackBar', true);
                    } else if (!this.phoneInput.isValidNumber()) {
                        document.getElementById('dial_transaction').setAttribute('href', "");
                        this.$store.commit('setSnackBarMessage', "Please input a valid phone number");
                        this.$store.commit('setSnackBarColor', "red darken-4");
                        this.$store.commit('activateSnackBar', true);
                        this.$refs.phone_number.focus();
                    } else if (this.pettycash_choice) {
                        this.Dialog = false;
                        this.$store.commit('setSnackBarMessage', "Please choose MOMO or OM, this option is currently unavailable");
                        this.$store.commit('setSnackBarColor', "teal darken-4");
                        this.$store.commit('activateSnackBar', true);
                    } else if (this.transaction_operator === "MTN Mobile Money" && this.save_amount !== "" && this.phoneInput.isValidNumber()) {
                        this.phone_number = this.phoneInput.getNumber();
                        this.Dialog = true;
                        this.transfer_code = `*126*4*${this.$store.state.MerchantCodeMTN}*${this.save_amount}#`;
                        let href_tel = `tel:*126*4*${this.$store.state.MerchantCodeMTN}*${this.save_amount}%23`;
                        document.getElementById('dial_transaction').setAttribute('href', href_tel);
                        document.getElementById('dial_transaction').setAttribute('target', "_blank");
                    } else if (this.transaction_operator === "Orange Money" && this.save_amount !== "" && this.phoneInput.isValidNumber()) {
                        this.phone_number = this.phoneInput.getNumber();
                        this.Dialog = true;
                        this.transfer_code = `#150*47*${this.$store.state.MerchantCodeOrange}*${this.save_amount}#`;
                        let href_tel = `tel:%23150*47*${this.$store.state.MerchantCodeOrange}*${this.save_amount}%23`;
                        document.getElementById('dial_transaction').setAttribute('href', href_tel);
                        document.getElementById('dial_transaction').setAttribute('target', "_blank");
                    } else if (this.transaction_operator === "Top Up Station" && this.save_amount !== "" && this.phoneInput.isValidNumber()) {
                        this.phone_number = this.phoneInput.getNumber();
                        this.Dialog = true;
                    }
                } catch (error) {
                    console.error("Error evaluating daily transaction limits:", error);
                }
            },

            async saveMoneyCampaign() {
                if (this.save_amount === "" || isNaN(Number(this.save_amount)) || Number(this.save_amount) <= 0) {
                    let message = this.save_amount === "" ? "Please input the amount" : "Please input only numbers for the amount";
                    this.$store.commit('setSnackBarMessage', message);
                    this.$store.commit('setSnackBarColor', "red darken-4");
                    this.$store.commit('activateSnackBar', true);
                    this.$refs.save_amount.focus();
                }
                else if (!this.phoneInput.isValidNumber()) {
                    this.$store.commit('setSnackBarMessage', "Phone number is invalid. Please input a valid number");
                    this.$store.commit('setSnackBarColor', "red darken-4");
                    this.$store.commit('activateSnackBar', true);
                    this.$refs.phone_number.focus();
                }
                else if (this.transaction_operator === "") {
                    this.$store.commit('setSnackBarMessage', "Please select the operator which you will send the money.");
                    this.$store.commit('setSnackBarColor', "red darken-4");
                    this.$store.commit('activateSnackBar', true);
                }
                else if (this.payment_ref === "") {
                    this.$store.commit('setSnackBarMessage', "An error occurred with the transaction, please try again later.");
                    this.$store.commit('setSnackBarColor', "red darken-4");
                    this.$store.commit('activateSnackBar', true);
                    window.location.reload();
                }
                else {
                    this.$store.commit('setIsLoading', true);
                    let formData = new FormData();
                    formData.append('payment_ref', this.payment_ref);
                    formData.append('save_amount', this.save_amount);
                    formData.append('phone_number', this.phone_number);
                    formData.append('transaction_operator', this.transaction_operator);

                    const campaign_id = this.$route.params.campaign_id;

                    try {
                        const response = await axios.post(`/api/v1/savings/save/campaign/${campaign_id}/`, formData, {
                            headers: {'Content-Type': 'multipart/form-data'}
                        });

                        this.$store.commit('setSnackBarMessage', response.data[0].text);
                        this.$store.commit('setSnackBarColor', response.data[0].color);
                        this.$store.commit('activateSnackBar', true);

                        if (response.data[0].valid) {
                            this.$store.commit('showPaymentVerification', {
                                amount: this.save_amount,
                                operator: this.transaction_operator,
                                phoneNumber: this.phone_number,
                                feature: 'marketplace',
                                id: campaign_id
                            });
                        }
                    } catch (error) {
                        if (error.response) {
                            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText);
                            this.$store.commit('setSnackBarColor', "red darken-4");
                            this.$store.commit('activateSnackBar', true);
                        } else {
                            this.$store.commit('setSnackBarMessage', "An error occurred, please check your internet connection and try again later.");
                            this.$store.commit('setSnackBarColor', "red darken-4");
                            this.$store.commit('activateSnackBar', true);
                        }
                    } finally {
                        this.$store.commit('setIsLoading', false);
                        this.Dialog = false;
                    }
                }
            },

            getHelpMessage() {
                if (this.save_amount_help) {
                    this.save_amount_help = false
                    this.$store.commit('setDialogTitle', "Save Amount")
                    this.$store.commit('setDialogMessage', "You are required to input your transaction amount.")
                    this.$store.commit('activateDialog', true)
                } else if (this.save_contact_help) {
                    this.save_contact_help = false
                    this.$store.commit('setDialogTitle', "Phone Contact")
                    this.$store.commit('setDialogMessage', "You are required to input the phone number used for the transaction.")
                    this.$store.commit('activateDialog', true)
                } else if (this.save_transaction_code_help) {
                    this.save_transaction_code_help = false
                    this.$store.commit('setDialogTitle', "Transaction ID")
                    this.$store.commit('setDialogMessage', "Please input the transaction ID or Code proving your transaction here.")
                    this.$store.commit('activateDialog', true)
                } else if (this.save_operator_help) {
                    this.save_operator_help = false
                    this.$store.commit('setDialogTitle', "Transaction Operator")
                    this.$store.commit('setDialogMessage', "Choose the operator, either MTN, Orange, Express Union, Western Union, Bank transactions etc. If its the Bank transaction, give account number here and account name, codes etc.")
                    this.$store.commit('activateDialog', true)
                }
            },
        },
    }
</script>